module.exports = __webpack_public_path__ + "static/media/ema.e1f2c3c6.png";